import myAPI from '../resources'
import config from '../../config'
import StorageManager from "../../utils/storageManager"
import router from '../../router'
import store from '../../store'

const carBuyUrl = config.carbuyservice;
const checkAuth = (err) => {
    if (err.response.status == 401) {
        store.dispatch("logout");
        router.push("/login");
    }
    return { data: err.response };
};

const getConfig = () => {
    return {
        headers: {
            'Authorization': `Bearer ${StorageManager.getJWT("CarBuyServiceJWT")}`
        }
    }
};

export default {
    post: (route, data = {}, useAuth = false) => {
        const axiosConfig = useAuth ? getConfig() : {};
        return myAPI.post(carBuyUrl + route, data, axiosConfig)
            .then(resp => {
                return resp;
            })
            .catch(checkAuth);
    },
    put: (route, data = {}, useAuth = false) => {
        const axiosConfig = useAuth ? getConfig() : {};
        return myAPI.put(carBuyUrl + route, data, axiosConfig)
            .then(resp => {
                return resp;
            })
            .catch(checkAuth);
    },
    patch: (route, data = {}, useAuth = false) => {
        const axiosConfig = useAuth ? getConfig() : {};
        return myAPI.patch(carBuyUrl + route, data, axiosConfig)
            .then(resp => {
                return resp;
            })
            .catch(checkAuth);
    },
    get: (route, data = {}, useAuth = false) => {
        const axiosConfig = useAuth ? { ...getConfig(), ...data } : data;
        return myAPI.get(carBuyUrl + route, axiosConfig)
            .then(resp => {
                return resp;
            })
            .catch(checkAuth);
    }
}


// WEBPACK FOOTER //
// ./src/api/clients/carBuyService.js